import Item from 'owa-service/lib/contract/Item';

/**
 * For each property that exists on the item in the cache, set it on the new item if it doesn't already have it.
 * @param newItem
 * @param itemInCache
 */
const preserveItemDataInCache = (newItem: Item, itemInCache: Item): void => {
    Object.keys(itemInCache).forEach(key => {
        if (!newItem[key]) {
            newItem[key] = itemInCache[key];
        }
    });
};

export default preserveItemDataInCache;
